import React from "react";
import { Box, HStack, Icon, Text, Tooltip } from "@chakra-ui/react";
import { AppIcons } from "constants/icons";

/** Section title bar for workflow Process tab (light bar + letter-spaced label, same spirit as data-scope panels). */
const WorkflowSectionHeading: React.FC<{
  icon?: React.ElementType;
  label: string;
  tooltip?: string;
  rightSlot?: React.ReactNode;
  /** Extra content rendered inline after the label (and optional tooltip), left-aligned */
  labelTrailing?: React.ReactNode;
  /** Tighter, smaller type for e.g. chat scenario artifact — default matches full workflow form. */
  compact?: boolean;
}> = ({ icon, label, tooltip, rightSlot, labelTrailing, compact = false }) => (
  <HStack
    w="100%"
    px={compact ? 2.5 : 3}
    py={compact ? 1 : 2}
    mb={compact ? 1 : 2}
    mt={compact ? 2 : 0}
    align="center"
    justify="space-between"
    spacing={2}
    flexWrap="wrap"
    textTransform="uppercase"
    fontWeight="700"
    bg="white"
    borderBottom={compact ? "0px" : "2px"}
    borderColor="gray.400"
  >
    <HStack spacing={1.5} align="center" minW={0}>
      {icon ? <Icon as={icon} boxSize={compact ? 4 : 5} color="purple.700" flexShrink={0} /> : null}
      <Text
        as="span"
        fontSize={compact ? "xs" : "sm"}
        fontWeight="800"
        color="gray.900"
        letterSpacing={compact ? "0.06em" : "0.08em"}
        whiteSpace="nowrap"
        lineHeight={compact ? 1.2 : undefined}
      >
        {label}
      </Text>
      {tooltip ? (
        <Tooltip
          label={tooltip}
          placement="top"
          hasArrow
          fontSize={compact ? "xs" : "sm"}
          bg="blue.50"
          color="gray.700"
          py={compact ? 1.5 : 2}
          px={compact ? 2 : 3}
          borderRadius="md"
          fontWeight="600"
        >
          <Box as="span" display="inline-flex" alignItems="center" lineHeight={1}>
            <Icon as={AppIcons.info} boxSize={compact ? 3 : 3.5} color="blue.400" cursor="help" />
          </Box>
        </Tooltip>
      ) : null}
      {labelTrailing ?? null}
    </HStack>
    {rightSlot ? <Box flexShrink={0}>{rightSlot}</Box> : null}
  </HStack>
);

export default WorkflowSectionHeading;
